import {PageDescription} from './page-description';
import {CCRoles} from '../../model/security/cc-roles-type';
import {AsbCCUrl} from './abs-cc-url';

  export class CrystalClearFrontUrlTools extends AsbCCUrl {
  // TOOLS
  static readonly TOOLS: PageDescription = {
    label: 'page_title.title.tools',
    icon: 'fas fa-tools icon-only',
    roles: CCRoles.ROLES_TOOLS
  };
  static readonly TOOLS_NOTIFY: PageDescription = {
    label: 'page_title.tools.notify',
    path: 'tools/notify',
    icon: 'fas fa-bell',
    roles: CCRoles.ROLES_TOOLS_ADMIN
  };
  static readonly TOOLS_SCHEDULER: PageDescription = {
    label: 'page_title.tools.scheduler',
    path: 'tools/scheduler',
    icon: 'fas fa-tasks',
    roles: CCRoles.ROLES_TOOLS_SCHEDULER
  };
  static readonly URLS: PageDescription[] = [
    CrystalClearFrontUrlTools.TOOLS_SCHEDULER,
  ];

}

